var exports = {
  "yu": "metadata__nb4DYC",
  "uD": "metadataDetails__GJjTiV",
  "q_": "agentDetails__jtAyQd",
  "dY": "agentSkeleton__Dhio82",
  "UG": "agentVisual__gFfcQY",
  "Gx": "agentNameSkeleton__oqy4rj",
  "XR": "metadataIcon__-o94Gb",
  "Dw": "creatorLink__N-0A-a",
  "Fp": "originLink__0O_17b",
  "yl": "originIcon__dwMeSj",
};

module.exports = exports;
